import { Component, Input, Output, OnInit,EventEmitter, ViewChild, ViewContainerRef, TemplateRef, AfterViewInit, OnDestroy } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { Subscription } from 'rxjs';

import { ProjectsService } from '@app/services/app/projects.service';

import { File } from '@core/objects/file';
import { FileMetadata } from '@core/objects/storage';
import * as Objects from '@core/objects';
import { CoreStorageFilesUploadComponent } from '@core/components/storage/storage-files-upload/storage-files-upload.component';

@Component({
    selector: 'project-details-info-attachments-upload',
    templateUrl: './upload.component.html',
    styleUrls: ['./upload.component.scss']
})
export class ProjectDetailsInfoAttachmentsUploadComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild(CoreStorageFilesUploadComponent) uploader: CoreStorageFilesUploadComponent;

    @Output() done = new EventEmitter<boolean>();
   
    public files: FileMetadata[] = [];
    public listFiles: Objects.AmsFile[] = [];
    public uploading: boolean = false;
    public submitted: boolean = false;

    protected subscriptor: Subscription;

	constructor(protected projectsSrv: ProjectsService ){}

    ngAfterViewInit() {
    }

	ngOnInit(){
        this.subscriptor = this.projectsSrv.selectProjectFiles().subscribe((files: Objects.AmsFile[] ) => {
            if(this.submitted) {
                if(files.length > this.listFiles.length) {
                    this.renderUploader();
                    this.sendDone();
                }
                this.files = []; //clean
                this.submitted = false;
            }
            this.listFiles = files;
        });
	}

    protected renderUploader() {
        this.uploader.files.clear();
    }


    public onSubmit(){
        this.submitted = true;
        console.debug("the files to upload are ", this.files);

        this.projectsSrv.uploadFiles(this.files);
    }

    public onCancel(){
        this.files = [];
        this.renderUploader();
        this.done.emit(); // the boolean is a flag to open the files list
    }

    protected sendDone() {
        this.done.emit(true);
    }

    ngOnDestroy() {
        this.subscriptor.unsubscribe();
        this.renderUploader();
    }


}
